import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { TracksPageLeftSideDrawerProps } from './types';
import { DcContainer } from './styles';
import { DrawerPages } from '../Drawer/DrawerPages';
import { DrawerLogos } from '../Drawer/DrawerLogos';
import { DrawerStorage } from '../Drawer/DrawerStorage';
import { DrawerProfileDetails } from '../Drawer/DrawerProfileDetails';
import { DrawerSocialMediaLinks } from '../Drawer/DrawerSocialMediaLinks';
import { useParams } from 'react-router-dom';
import { GuestShellBanner } from '../Guest';

export const Drawer: React.FC<TracksPageLeftSideDrawerProps> = ({
  currentUser,
  isDrawerOpen,
  setIsDrawerOpen,
}) => {
  const [currentPage, setCurrentPage] = useState('Tracks');
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem('sidebar_collapsed') === 'true'
  );

  const handleToggleCollapsed = () => {
    setCollapsed((prev) => {
      const next = !prev;
      localStorage.setItem('sidebar_collapsed', String(next));
      return next;
    });
  };
  const { id } = useParams();

  useEffect(() => {
    if (window.location.href.includes('explore')) {
      setCurrentPage('Explore');
    } else if (window.location.href.includes('my-tracks')) {
      setCurrentPage('Hub');
    } else if (window.location.href.includes('projects') && id !== 'undefined') {
      setCurrentPage('Projects');
    }
  }, [id]);

  return (
    <>
      <DcContainer collapsed={collapsed}>
        <Box>
          <DrawerLogos
            isDrawerOpen={isDrawerOpen}
            setIsDrawerOpen={setIsDrawerOpen}
            collapsed={collapsed}
            onToggleCollapsed={handleToggleCollapsed}
          />
          <DrawerPages
            currentUser={currentUser}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            collapsed={collapsed}
          />
        </Box>
        <Box>
          {!collapsed && <GuestShellBanner />}
          {!collapsed && <DrawerStorage currentUser={currentUser} />}
          <DrawerProfileDetails currentUser={currentUser} collapsed={collapsed} />
          {!collapsed && <DrawerSocialMediaLinks />}
        </Box>
      </DcContainer>
    </>
  );
};
